import React from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import Add from '@material-ui/icons/AddCircleOutline';
import SaveIcon from '@material-ui/icons/Save';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Header from './Header';
import api from '../api/api';

export default class Document extends React.Component {
  constructor() {
    super();
    this.state = {
      vhdReceivedDate: '',
      gateEntryNo: '',
      gateEntryDate: '',
      sapGateEntryNo: '',
      sapGateEntryDate: '',
      pcDcNo: '',
      pcDcDate: '',
      project: '',
      documentType: '',
      natureOfConsignment: '',
      boeNo: '',
      boeDate: '',
      lrNo: '',
      currencyType: '',
      invoiceAmount: '',
      exchangeRate: '',
      amount: '',
      invoiceNo: '',
      invoiceDate: '',
      vendor: '',
      poNo: '',
      poDate: '',
      poAmount: '',
      creditPeriod: '',
      userDepartment: '',
      userName: '',
      itemDescription: '',
      newProjectName: '',
      newDocumentType: '',
      newNatureOfConsignment: '',
      newCurrencyType: '',
      newVendorCode: '',
      newVendorName: '',
      newVendorContactNumber: '',
      newVendorAddress: '',
      newUserDept: '',
      projects: [],
      documentTypes: [],
      consignments: [],
      currencyTypes: [],
      vendors: [],
      userDeptList: [],
      projectVisible: false,
      documentTypeVisible: false,
      consignmentVisible: false,
      currencyTypeVisible: false,
      vendorVisible: false,
      userDeptVisible: false,
      userNameVisible: false,
      vendorCodeError: false,
      vendorNameError: false,
      userDeptError: false,
      currencyTypeError: false,
      consignmentNatureError: false,
      documentTypeError: false,
      projectNameError: false
    };
    this.onProjectClick = this.onProjectClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onConsignmentClick = this.onConsignmentClick.bind(this);
    this.onCurrencyClick = this.onCurrencyClick.bind(this);
    this.onVendorClick = this.onVendorClick.bind(this);
    this.onUserDeptClick = this.onUserDeptClick.bind(this);
    this.onUserNameClick = this.onUserNameClick.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  onProjectClick(event) {
    this.setState({projectVisible: true});
  }

  onDocumentClick(event) {
    this.setState({documentTypeVisible: true});
  }

  onConsignmentClick(event) {
    this.setState({consignmentVisible: true});
  }

  onCurrencyClick(event) {
    this.setState({currencyTypeVisible: true});
  }

  onVendorClick(event) {
    this.setState({vendorVisible: true});
  }

  onUserDeptClick(event) {
    this.setState({userDeptVisible: true});
  }

  onUserNameClick(event) {
    this.setState({userNameVisible: true});
  }

  onHide(event) {
    this.setState ({
      projectVisible: false,
      documentTypeVisible: false,
      consignmentVisible: false,
      currencyTypeVisible: false,
      vendorVisible: false,
      userDeptVisible: false
    })
  }

  onProjectAdd = (e) => {
    e.preventDefault();
    var projectName = this.state.newProjectName;
    if (projectName === '') {
      this.setState({
        projectNameError: true
      });
      return;
    }
    else {
      // Invoke post Project API
      api.postProject(projectName).then((response) => {
        if(response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if(res.project_id) {
              this.setState({
                projectVisible: false,
                project: res.project_id,
                newProjectName: ''
              });
              // Invoke get Projects list API
              api.getProjects().then((response) => {
                if(response.status >= 200 && response.status < 300) {
                  response.json().then((res) => {
                    if(res.projects) {
                      let projectsList = [];
                      let keys = [];
                      for (var key in res.projects) {
                        projectsList.push({label: res.projects[key].project_name, value: res.projects[key].id});
                        keys.push({key});
                      }
                      this.setState({
                        projects : projectsList
                      });
                    }
                    else {
                      alert('TODO:: Error Handling in Projects.');
                    }
                  });
                }
                else {
                  alert('Error Handling in header1.');
                }
              });
            }
            else {
              alert('Something went wrong. Please try again later.');
            }
          });
        }
        else if (response.status === 601) {
          alert('Missing mandatory field(s)');
        }
      });
    }
  }
  
  onDocumentTypeAdd = (e) => {
    e.preventDefault();
    var documentType = this.state.newDocumentType;
    if (documentType === '') {
      this.setState({
        documentTypeError: true
      });
      return;
    }
    else {
      // Invoke post Document Type API
      api.postDocumentType(documentType).then((response) => {
        if(response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if(res.document_id) {
              this.setState({
                documentTypeVisible: false,
                documentType: res.document_id,
                newDocumentType: ''
              });
              // Invoke get Document Types list API
              api.getDocumentTypes().then((response) => {
                if(response.status >= 200 && response.status < 300) {
                  response.json().then((res) => {
                    if(res.document_types) {
                      let documentTypesList = [];
                      let keys = [];
                      for (var key in res.document_types) {
                        documentTypesList.push({label: res.document_types[key].document_type, value: res.document_types[key].id});
                        keys.push({key});
                      }
                      this.setState({
                        documentTypes : documentTypesList
                      });
                    }
                    else {
                      alert('TODO:: Error Handling in Document Types..');
                    }
                  });
                }
                else {
                  alert('Error Handling in header1.');
                }
              });
            }
            else {
              alert('Something went wrong. Please try again later.');
            }
          });
        }
        else if (response.status === 601) {
          alert('Missing mandatory field(s)');
        }
      });
    }
  }
  
  onConsignmentAdd = (e) => {
    e.preventDefault();
    var consignmentNature = this.state.newNatureOfConsignment;
    if (consignmentNature === '') {
      this.setState({
        consignmentNatureError: true
      });
      return;
    }
    else {
      // Invoke post Consignment API
      api.postConsignment(consignmentNature).then((response) => {
        if(response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if(res.consignment_id) {
              this.setState({
                consignmentVisible: false,
                natureOfConsignment: res.consignment_id,
                newNatureOfConsignment: ''
              });
              // Invoke Get Consignments list API
              api.getConsignments().then((response) => {
                if(response.status >= 200 && response.status < 300) {
                  response.json().then((res) => {
                    if(res.consignments) {
                      let consignmentList = [];
                      let keys = [];
                      for (var key in res.consignments) {
                        consignmentList.push({label: res.consignments[key].nature_of_consignment, value: res.consignments[key].id});
                        keys.push({key});
                      }
                      this.setState({
                        consignments : consignmentList
                      });
                    }
                    else {
                      alert('TODO:: Error Handling in Document Types..');
                    }
                  });
                }
                else {
                  alert('Error Handling in header1.');
                }
              });
            }
            else {
              alert('Something went wrong. Please try again later.');
            }
          });
        }
        else if (response.status === 601) {
          alert('Missing mandatory field(s)');
        }
      });
    }
  }
  
  onCurrencyTypeAdd = (e) => {
    e.preventDefault();
    var currencyType = this.state.newCurrencyType;
    if (currencyType === '') {
      this.setState({
        currencyTypeError: true
      });
      return;
    }
    else {
      // Invoke post Currency Type API
      api.postCurrencyType(currencyType).then((response) => {
        if(response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if(res.currency_type_id) {
              this.setState({
                currencyTypeVisible: false,
                currencyType: res.currency_type_id,
                newCurrencyType: ''
              });
              // Invoke Get Currency Types list API
              api.getCurrencyTypes().then((response) => {
                if(response.status >= 200 && response.status < 300) {
                  response.json().then((res) => {
                    if(res.currency_types) {
                      let currencyTypeList = [];
                      let keys = [];
                      for (var key in res.currency_types) {
                        currencyTypeList.push({label: res.currency_types[key].currency_type, value: res.currency_types[key].id});
                        keys.push({key});
                      }
                      this.setState({
                        currencyTypes : currencyTypeList
                      });
                    }
                    else {
                      alert('TODO:: Error Handling in Document Types..');
                    }
                  });
                }
                else {
                  alert('Error Handling in header1.');
                }
              });
            }
            else {
              alert('Something went wrong. Please try again later.');
            }
          });
        }
        else if (response.status === 601) {
          alert('Missing mandatory field(s)');
        }
      });
    }
  }
  
  onVendorAdd = (e) => {
    e.preventDefault();
    var vendorCode = this.state.newVendorCode;
    var vendorName = this.state.newVendorName;
    var vendorContact = this.state.newVendorContactNumber;
    var vendorAddress = this.state.newVendorAddress;
    if (vendorCode === '') {
      this.setState({
        vendorCodeError: true
      });
      return;
    }
    else if(vendorName === '') {
      this.setState({
        vendorNameError: true
      });
      return;
    }
    else {
      // Invoke post Currency Type API
      api.postNewVendor(vendorCode, vendorName, vendorContact, vendorAddress).then((response) => {
        if(response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if(res.vendor_id) {
              this.setState({
                vendorVisible: false,
                vendor: res.vendor_id,
                newVendorCode: '',
                newVendorName: '',
                newVendorContactNumber: '',
                newVendorAddress: ''
              });
              // Invoke Get Currency Types list API
              api.getVendors().then((response) => {
                if(response.status >= 200 && response.status < 300) {
                  response.json().then((res) => {
                    if(res.vendors) {
                      let vendorsList = [];
                      let keys = [];
                      for (var key in res.vendors) {
                        vendorsList.push({label: res.vendors[key].vendor_name + ' (' + res.vendors[key].vendor_code +')' , value: res.vendors[key].id});
                        keys.push({key});
                      }
                      this.setState({
                        vendors : vendorsList
                      });
                    }
                    else {
                      alert('TODO:: Error Handling in Document Types..');
                    }
                  });
                }
                else {
                  alert('Error Handling in header1.');
                }
              });
            }
            else {
              alert('Something went wrong. Please try again later.');
            }
          });
        }
        else if (response.status === 601) {
          alert('Missing mandatory field(s)');
        }
      });
    }
  }
  
  onUserDeptAdd = (e) => {
    e.preventDefault();
    var userDept = this.state.newUserDept;
    if (userDept === '') {
      this.setState({
        userDeptError: true
      });
      return;
    }
    else {
      // Invoke post Currency Type API
      api.postUserDept(userDept).then((response) => {
        if(response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if(res.department_id) {
              this.setState({
                userDeptVisible: false,
                userDepartment: res.department_id,
                newUserDept: ''
              });
              // Invoke Get User Department list API
              api.getUserDepts().then((response) => {
                if(response.status >= 200 && response.status < 300) {
                  response.json().then((res) => {
                    if(res.user_departments) {
                      let userDeptList = [];
                      let keys = [];
                      for (var key in res.user_departments) {
                        userDeptList.push({label: res.user_departments[key].department_name, value: res.user_departments[key].id});
                        keys.push({key});
                      }
                      this.setState({
                        userDeptList : userDeptList
                      });
                    }
                    else {
                      alert('TODO:: Error Handling in Document Types..');
                    }
                  });
                }
                else {
                  alert('Error Handling in header1.');
                }
              });
            }
            else {
              alert('Something went wrong. Please try again later.');
            }
          });
        }
        else if (response.status === 601) {
          alert('Missing mandatory field(s)');
        }
      });
    }
  }

  handleSubmit = (e) => {
    var companyCode = '001';
    var {vhdReceivedDate} = this.state;
    var {gateEntryNo} = this.state;
    var {gateEntryDate} = this.state;
    var {sapGateEntryNo} = this.state;
    var {sapGateEntryDate} = this.state;
    var {pcDcNo} = this.state;
    var {pcDcDate} = this.state;
    var {project} = this.state;
    var {documentType} = this.state;
    var {natureOfConsignment} = this.state;
    var {boeNo} = this.state;
    var {boeDate} = this.state;
    var {lrNo} = this.state;
    var {currencyType} = this.state;
    var {invoiceAmount} = this.state;
    var {exchangeRate} = this.state;
    var {amount} = this.state;
    var {invoiceNo} = this.state;
    var {invoiceDate} = this.state;
    var {vendor} = this.state;
    var {poNo} = this.state;
    var {poDate} = this.state;
    var {poAmount} = this.state;
    var {creditPeriod} = this.state;
    var {userDepartment} = this.state;
    var {userName} = this.state;
    var {itemDescription} = this.state;
    // Invoke post Currency Type API
    api.postDocument(companyCode, vhdReceivedDate, gateEntryNo, gateEntryDate, sapGateEntryNo, sapGateEntryDate, pcDcNo, pcDcDate, project, 
                     documentType, natureOfConsignment, boeNo, boeDate, lrNo, currencyType, invoiceAmount, exchangeRate, amount, invoiceNo, 
                     invoiceDate, vendor, poNo, poDate, poAmount, creditPeriod, userDepartment, userName, itemDescription).then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.document_id) {
            alert('Document Added Successfully!!');
            this.props.history.replace('/');
          }
          else {
            alert('Something went wrong. Please try again later.');
          }
        });
      }
      else if (response.status === 601) {
        alert('Missing mandatory field(s)');
      }
      else if (response.status === 605) {
        alert('Document already exist with a combination of Invoice No, Invoice Date and Vendor.');
      }
    });
  }

  componentWillMount() {
    // Invoke get Projects list API
    api.getProjects().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.projects) {
            let projectsList = [];
            let keys = [];
            for (var key in res.projects) {
              projectsList.push({value: res.projects[key].id, label: res.projects[key].project_name});
              keys.push({key});
            }
            this.setState({
              projects : projectsList
            });
          }
          else {
            alert('TODO:: Error Handling in Projects..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
    // Invoke get Document Types list API
    api.getDocumentTypes().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.document_types) {
            let documentTypesList = [];
            let keys = [];
            for (var key in res.document_types) {
              documentTypesList.push({label: res.document_types[key].document_type, value: res.document_types[key].id});
              keys.push({key});
            }
            this.setState({
              documentTypes : documentTypesList
            });
          }
          else {
            alert('TODO:: Error Handling in Document Types..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
    // Invoke Get Consignments list API
    api.getConsignments().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.consignments) {
            let consignmentList = [];
            let keys = [];
            for (var key in res.consignments) {
              consignmentList.push({label: res.consignments[key].nature_of_consignment, value: res.consignments[key].id});
              keys.push({key});
            }
            this.setState({
              consignments : consignmentList
            });
          }
          else {
            alert('TODO:: Error Handling in Document Types..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
    // Invoke Get Currency Types list API
    api.getCurrencyTypes().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.currency_types) {
            let currencyTypeList = [];
            let keys = [];
            for (var key in res.currency_types) {
              currencyTypeList.push({label: res.currency_types[key].currency_type, value: res.currency_types[key].id});
              keys.push({key});
            }
            this.setState({
              currencyTypes : currencyTypeList
            });
          }
          else {
            alert('TODO:: Error Handling in Document Types..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
    // Invoke Get Currency Types list API
    api.getVendors().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.vendors) {
            let vendorsList = [];
            let keys = [];
            for (var key in res.vendors) {
              vendorsList.push({label: res.vendors[key].vendor_name + ' (' + res.vendors[key].vendor_code +')' , value: res.vendors[key].id});
              keys.push({key});
            }
            this.setState({
              vendors : vendorsList
            });
          }
          else {
            alert('TODO:: Error Handling in Document Types..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
    // Invoke Get User Department list API
    api.getUserDepts().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.user_departments) {
            let userDeptList = [];
            let keys = [];
            for (var key in res.user_departments) {
              userDeptList.push({label: res.user_departments[key].department_name, value: res.user_departments[key].id});
              keys.push({key});
            }
            this.setState({
              userDeptList : userDeptList
            });
          }
          else {
            alert('TODO:: Error Handling in Document Types..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
  }

  render() {
    return (
      <div>
        <Header />
        <div>
          <Paper style={{padding: '10px', margin: '10px'}}>
            <Grid container spacing={24} style={{width:'100%'}}>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="companyName"
                  name="companyName"
                  label="Company Name"
                  defaultValue= "Company One"
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="vhdDate"
                  name="vhdDate"
                  label="VHD Received Date"
                  type="date"
                  fullWidth
                  autoFocus={true}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({vhdReceivedDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="gateEntryNo"
                  name="gateEntryNo"
                  label="Gate Entry No"
                  fullWidth
                  onChange={(e) => this.setState({gateEntryNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="gateEntryDate"
                  name="gateEntryDate"
                  label="Gate Entry Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({gateEntryDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="sapGateEntryNo"
                  name="sapGateEntryNo"
                  label="SAP Gate entry No"
                  fullWidth
                  onChange={(e) => this.setState({sapGateEntryNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="sapGateEntryDate"
                  name="sapGateEntryDate"
                  label="SAP Gate Entry Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({sapGateEntryDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="pcDcNo"
                  name="pcDcNo"
                  label="PC No/Dc No"
                  fullWidth
                  onChange={(e) => this.setState({pcDcNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="pcDcDate"
                  name="pcDcDate"
                  label="PC/DC Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({pcDcDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.project}
                  id="project"
                  name="project"
                  label="Project"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onProjectClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({project: e.target.value})}}
                >
                  {this.state.projects.map((option,id) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.documentType}
                  id="documentType"
                  name="documentType"
                  label="Document Type"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onDocumentClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({documentType: e.target.value})}}
                >
                  {this.state.documentTypes.map((option,id) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.natureOfConsignment}
                  id="natureOfConsignment"
                  name="natureOfConsignment"
                  label="Nature of Consignment"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onConsignmentClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({natureOfConsignment: e.target.value})}}
                >
                  {this.state.consignments.map((option,id) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="boeNo"
                  name="boeNo"
                  label="BOE No"
                  fullWidth
                  onChange={(e) => this.setState({boeNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="boeDate"
                  name="boeDate"
                  label="BOE Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({boeDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="lrNo"
                  name="lrNo"
                  label="LR No"
                  fullWidth
                  onChange={(e) => this.setState({lrNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.currencyType}
                  id="currencyType"
                  name="currencyType"
                  label="Currency Type"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onCurrencyClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({currencyType: e.target.value})}}
                >
                  {this.state.currencyTypes.map((option,id) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="invoiceAmount"
                  name="invoiceAmount"
                  label="Amt (Invoice Currency)"
                  fullWidth
                  onChange={(e) => this.setState({invoiceAmount: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="exchangeRate"
                  name="exchangeRate"
                  label="Exchange Rate"
                  fullWidth
                  onChange={(e) => this.setState({exchangeRate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="amount"
                  name="amount"
                  label="Amt (INR)"
                  fullWidth
                  onChange={(e) => this.setState({amount: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="invoiceNo"
                  name="invoiceNo"
                  label="Invoice No"
                  fullWidth
                  onChange={(e) => this.setState({invoiceNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="invoiceDate"
                  name="invoiceDate"
                  label="Invoice Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({invoiceDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.vendor}
                  id="vendor"
                  name="vendor"
                  label="Vendor"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onVendorClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({vendor: e.target.value})}}
                >
                  {this.state.vendors.map((option,id) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="poNo"
                  name="poNo"
                  label="PO No"
                  fullWidth
                  onChange={(e) => this.setState({poNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="poDate"
                  name="poDate"
                  label="PO Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({poDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="poAmount"
                  name="poAmount"
                  label="PO Amount"
                  fullWidth
                  onChange={(e) => this.setState({poAmount: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="creditPeriod"
                  name="creditPeriod"
                  label="Credit Period"
                  fullWidth
                  onChange={(e) => this.setState({creditPeriod: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.userDepartment}
                  id="userDepartment"
                  name="userDepartment"
                  label="User Dept"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onUserDeptClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({userDepartment: e.target.value})}}
                >
                  {this.state.userDeptList.map((option,id) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.userName}
                  id="userName"
                  name="userName"
                  label="User Name"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onUserNameClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({userName: e.target.value})}}
                >
                  <MenuItem key="1" value="Hemanth">Hemanth</MenuItem>
                  <MenuItem key="2" value="Suresh">Suresh</MenuItem>
                  <MenuItem key="3" value="Rajesh">Rajesh</MenuItem>
                  <MenuItem key="4" value="Mahesh">Mahesh</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="itemDescription"
                  name="itemDescription"
                  label="Item Description"
                  fullWidth
                  multiline
                  onChange={(e) => this.setState({itemDescription: e.target.value})}
                />
              </Grid>
            </Grid><br/><br/><br/>
            <div className="icon-bar">
              <Button variant="contained" color="primary" size="small" style={{textTransform: 'initial', width: '100px'}} onClick={this.handleSubmit} >
                <SaveIcon />&nbsp;&nbsp;Submit
              </Button>
            </div>
          </Paper>
          <Dialog open={this.state.projectVisible} fullWidth >
            <DialogTitle style={{backgroundColor: '#c7c7c75c', padding: '18px', marginBottom: '10px'}} id="form-dialog-title">Add New Project Name</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                id="newProjectName"
                label="Project Name"
                fullWidth
                required
                error={this.state.projectNameError}
                onChange={(e) => this.setState({newProjectName: e.target.value, projectNameError:false})}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.onHide} color="primary">
                Cancel
              </Button>
              <Button onClick={this.onProjectAdd} color="primary">
                Submit
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={this.state.documentTypeVisible} fullWidth >
            <DialogTitle style={{backgroundColor: '#c7c7c75c', padding: '18px', marginBottom: '10px'}} id="form-dialog-title">Add New Document Type</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                id="newDocumentType"
                label="Document Type"
                fullWidth
                required
                error={this.state.documentTypeError}
                onChange={(e) => this.setState({newDocumentType: e.target.value, documentTypeError: false})}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.onHide} color="primary">
                Cancel
              </Button>
              <Button onClick={this.onDocumentTypeAdd} color="primary">
                Submit
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={this.state.consignmentVisible} fullWidth >
            <DialogTitle style={{backgroundColor: '#c7c7c75c', padding: '18px', marginBottom: '10px'}} id="form-dialog-title">Add Nature of Consignment</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                id="newNatureOfConsignment"
                label="Nature of Consignment"
                fullWidth
                required
                error={this.state.consignmentNatureError}
                onChange={(e) => this.setState({newNatureOfConsignment: e.target.value, consignmentNatureError: false})}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.onHide} color="primary">
                Cancel
              </Button>
              <Button onClick={this.onConsignmentAdd} color="primary">
                Submit
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={this.state.currencyTypeVisible} fullWidth >
            <DialogTitle style={{backgroundColor: '#c7c7c75c', padding: '18px', marginBottom: '10px'}} id="form-dialog-title">Add New Currency Type</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                id="newCurrencyType"
                label="Currency Type"
                fullWidth
                required
                error={this.state.currencyTypeError}
                onChange={(e) => this.setState({newCurrencyType: e.target.value, currencyTypeError: false})}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.onHide} color="primary">
                Cancel
              </Button>
              <Button onClick={this.onCurrencyTypeAdd} color="primary">
                Submit
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={this.state.vendorVisible} fullWidth >
            <DialogTitle style={{backgroundColor: '#c7c7c75c', padding: '18px', marginBottom: '10px'}} id="form-dialog-title">Add New Vendor</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus={true}
                id="newVendorCode"
                label="Vendor Code"
                fullWidth
                required
                error={this.state.vendorCodeError}
                onChange={(e) => this.setState({newVendorCode: e.target.value, vendorCodeError: false})}
              />
              <TextField
                id="newVendorName"
                label="Vendor Name"
                fullWidth
                required
                error={this.state.vendorNameError}
                onChange={(e) => this.setState({newVendorName: e.target.value, vendorNameError: false})}
              />
              <TextField
                id="newVendorContactNumber"
                label="Vendor Contact Number"
                fullWidth
                onChange={(e) => this.setState({newVendorContactNumber: e.target.value})}
              />
              <TextField
                id="newVendorAddress"
                label="Vendor Address"
                fullWidth
                onChange={(e) => this.setState({newVendorAddress: e.target.value})}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.onHide} color="primary">
                Cancel
              </Button>
              <Button onClick={this.onVendorAdd} color="primary">
                Submit
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={this.state.userDeptVisible} fullWidth >
            <DialogTitle style={{backgroundColor: '#c7c7c75c', padding: '18px', marginBottom: '10px'}} id="form-dialog-title">Add New User Department</DialogTitle>
            <DialogContent>
              <TextField
                id="newUserDept"
                label="User Dept"
                fullWidth
                autoFocus={true}
                error={this.state.userDeptError}
                onChange={(e) => this.setState({newUserDept: e.target.value, userDeptError: false})}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.onHide} color="primary">
                Cancel
              </Button>
              <Button onClick={this.onUserDeptAdd} color="primary">
                Submit
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Document.js